import * as React from 'react';
import MMSEForm from './MMSE';
import MOCAForm from './MOCA';
import TMTForm from './TMT';
import SDMTForm from './SDMT';
import CDRForm from './CDR';
import CERADForm from './CERAD';
import { TDocument } from '../definitions';

const CognitionForm = ({ documents, formData, document, viewing = false }: IOwnProps): React.JSX.Element | null =>
  document?._type === 'moca' ? (
    <MOCAForm formData={formData as IFormData<IMOCA>} viewing={viewing} />
  ) : document?._type === 'mmse' ? (
    <MMSEForm formData={formData as IFormData<IMMSE>} viewing={viewing} />
  ) : document?._type === 'tmt' ? (
    <TMTForm formData={formData as IFormData<ITMT>} viewing={viewing} />
  ) : document?._type === 'sdmt' ? (
    <SDMTForm formData={formData as IFormData<ISDMT>} viewing={viewing} />
  ) : document?._type === 'cdr' ? (
    <CDRForm formData={formData as IFormData<ICDR>} viewing={viewing} />
  ) : document?._type === 'cerad' ? (
    <CERADForm documents={documents} formData={formData as IFormData<ICERAD2023>} viewing={viewing} />
  ) : null;

interface IOwnProps {
  documents: Array<TDocument>;
  formData: IFormData<TDocument>;
  document?: TDocument;
  viewing?: boolean;
}

export default CognitionForm;
